import api, { ensureCsrfCookie } from '../config/api';

export const login = (email, password) =>
    ensureCsrfCookie().then(() =>
        api.post('/auth/login', { email, password }).then((res) => res.data)
    );

export const register = (name, email, password, passwordConfirmation) =>
    ensureCsrfCookie().then(() =>
        api
            .post('/auth/register', {
                name,
                email,
                password,
                password_confirmation: passwordConfirmation,
            })
            .then((res) => res.data)
    );

export const logout = () => api.post('/auth/logout').then((res) => res.data);

export const me = () => api.get('/auth/me').then((res) => res.data);
